import type { FaireProductEntity } from "../../entity_types/product";

export const p_7sskarqtdh: FaireProductEntity = {
  token: "p_7sskarqtdh",
  type: "product",
  name: "White Hustle Dress Shirt - Long Sleeve",
  brandToken: "b_74j5lq342s",
  brandName: "Tough Apparel",
  imageUrl: "https://cdn.faire.com/fastly/9847418a8c5b2aaf1e6d3415a23329e07cf764252f9ff2d9bcfc7100c3c11641.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e95da999320955060a0ac3655336481ca99b9ace5ee6447c102df27e1073cb07.png",
    "https://cdn.faire.com/fastly/2e91ae06e01813aabac6ec4a6accacbfb8c7209f9d175598fc411efc980f9ec5.png",
    "https://cdn.faire.com/fastly/fe5f877024e43911d6587845cf17f23605923f6dddd7b8533a3c19070cc35512.png",
    "https://cdn.shopify.com/s/files/1/1461/5016/files/updatedshirtpicssvg-03.svg?v=1765310428",
    "https://cdn.faire.com/fastly/0efd02ede7f0f1660c087a7cbc97a7fc536f7f5ac1a1a2ce7627231825e34e64.jpeg",
    "https://cdn.faire.com/fastly/878bf00c9ad6aba0d3a57d19cb097b3db8a173306e6011f4f18d49e738508882.jpeg",
    "https://cdn.faire.com/fastly/5ecbe9f467929b272b79fca54981de2491fe8383180affce870316175fe4d599.png",
    "https://cdn.faire.com/fastly/7e1cff0e0904bb39cfe263e21188b0815416f84f94274fe7408ceed7985da4e4.png",
    "https://cdn.faire.com/fastly/52317cf677793ad2601e2e0828188b38c2ed2e2cf8eef59446d98d1a76ec61cc.png",
    "https://cdn.faire.com/fastly/cbf880d773d11fa082d867e8686883a4b757e0b04b0bea79324f1c88fe85ceca.jpeg",
    "https://cdn.faire.com/fastly/564286495617bbb8f31f317f0219233a51e5bb0a50a6a3959af0951a529d37d2.png",
    "https://cdn.faire.com/fastly/a54ee190acb0c3981986476100eec862c07f7b9535e23a05f108e790c4e87242.png",
    "https://cdn.faire.com/fastly/ff1f5eade4962978423e38f231f7c709ab56c4c5fd77dc7d364734b53c9b0422.jpeg",
    "https://cdn.shopify.com/s/files/1/1461/5016/files/updatedshirtpicssvg-01.svg?v=1765310428",
    "https://cdn.shopify.com/s/files/1/1461/5016/files/updatedshirtpicssvg-02.svg?v=1765310428",
    "https://cdn.faire.com/fastly/9f13afdaebecb397942a11066ff1a9e8d9c1dc1b74e7b2aafb37f8033a623027.jpeg",
    "https://cdn.faire.com/fastly/bbb5be85db8cab9fc4f9eaf37a2e9daef040ec95ff0f8102965333aa935fb1cb.jpeg",
    "https://cdn.faire.com/fastly/a2a62990ad1513a615029a3172aa20c1805f6cf79397d12f04fdcd7f0ae1a262.jpeg"
  ],
  priceDollars: 27.5,
  description: "The Most Comfortable Performance Dress Shirt you can actually afford.\n\nThe Hustle Performance Dress Shirt, where comfort meets performance.\n\n• Performance Fabric Dress Shirt\n• 4 Way Stretch for Ultimate Comfort\n• Wrinkle Resistant\n• Stain Resistant\n• Collar Shield\n• Lightweight and Breathable\n• 37% Recycled, 48% Polyester, 15% Spandex",
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T18:43:23.745Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
